import Vue from 'vue'
import App from './App.vue'
import '@/plugins/element.js'
import NotificationPlugin from '@/plugins/notification.js'
import router from './router'
import store from './store'
import FontFaceObserver from 'fontfaceobserver'
import LucideIcon from '@/components/LucideIcon.vue'

Vue.component('LucideIcon', LucideIcon)
Vue.use(NotificationPlugin)

Vue.config.productionTip = false

const font = new FontFaceObserver('Ubuntu Mono')

font.load().then(() => {
  document.documentElement.classList.add('font-loaded')

  new Vue({
    router,
    store,
    render: h => h(App)
  }).$mount('#app')
}).catch(() => {
  console.warn('A fonte Ubuntu Mono não foi carregada a tempo.')
  new Vue({
    router,
    store,
    render: h => h(App)
  }).$mount('#app')
})
